import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import { BOOLEAN_OPTIONS, Question } from '@ratehub/base-ui';


function QuestionWantsBundledQuote({ value }) {
    return (
        <Question
            field={{
                name: 'wantsBundledQuote',
                type: 'boolean',
                value,
                options: BOOLEAN_OPTIONS,
            }}
            type="radio"
            labelMessage={(
                <FormattedMessage
                    id="InsLifeWizard.CoverageDetailsPage.wantsBundledQuote"
                    defaultMessage="Would you like to receive a complementary auto or home insurance quote from our brokerage RH Insurance?"
                />
            )}
            tooltipMessage={(
                <FormattedMessage
                    id="InsLifeWizard.CoverageDetailsPage.wantsBundledQuoteTooltip"
                    defaultMessage="Our 5-star brokerage is here to help you find the best rates for auto & home insurance. We'll help you compare the market to make sure you get the right coverage at the right price."
                />
            )}
            shouldDisplayOptionsAsGrid
        />
    );
}

QuestionWantsBundledQuote.propTypes = {
    value: PropTypes.bool,
};

export default observer(QuestionWantsBundledQuote);
